import { useEffect } from "react";
import { useLocation } from "wouter";

/**
 * ScrollToTop component that smoothly scrolls to the top of the page
 * whenever the route changes. Optimized for iOS Safari compatibility.
 */
export function ScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    // Use requestAnimationFrame for smoother scrolling on iOS
    requestAnimationFrame(() => {
      // Try multiple scroll targets for better cross-browser compatibility
      // This is especially important for iOS Safari which can be quirky
      
      // 1. Try scrolling the main window
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });

      // 2. Also try scrolling the document element (for some browsers)
      document.documentElement.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });

      // 3. Fallback: Reset scroll position directly for browsers that don't support smooth scroll
      // This ensures it works even on older iOS versions
      setTimeout(() => {
        if (window.pageYOffset > 0 || document.documentElement.scrollTop > 0) {
          window.scrollTo(0, 0);
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0; // For older browsers
        }
      }, 100);
    });
  }, [location]); // Trigger on location change

  return null; // This component doesn't render anything
}

